<section class="section" id="education">
  <div class="container">
    <div class="section-head">
      <p class="eyebrow">Diplômes</p>
      <h2>Formation et socle académique</h2>
      <p class="section-sub">
        Un parcours structuré, orienté architecture logicielle et qualité d\'ingénierie.
      </p>
    </div>

    <div class="education-grid">
      @for (item of education; track item.degree + item.year) {
        <article class="education-card" appReveal>
        <div>
          <h3>{{ item.degree }}</h3>
          <p class="school">{{ item.school }}</p>
        </div>
        <span class="year">{{ item.year }}</span>
        @if (item.description) {
          <p class="description">{{ item.description }}</p>
        }
      </article>
      }
    </div>
  </div>
</section>
